/* Secciones Alv: reproducir videos solo cuando están en pantalla, flechas de carrusel y sonido al tocar */
(function () {
  if (window.__alvInit) return;
  window.__alvInit = true;

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.35 }) : null;

  function bind(root) {
    root.querySelectorAll('video[data-alv-autoplay], [data-alv-autoplay] video').forEach(function (v) {
      if (v.__alv) return; v.__alv = true;
      v.muted = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
      if (io) io.observe(v); else v.play();
    });
    root.querySelectorAll('[data-alv-sound]').forEach(function (btn) {
      if (btn.__alv) return; btn.__alv = true;
      btn.addEventListener('click', function () {
        var v = btn.closest('.alv-media').querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        btn.setAttribute('aria-pressed', String(!v.muted));
        btn.textContent = v.muted ? '🔇' : '🔊';
        if (!v.muted) v.play();
      });
    });
    root.querySelectorAll('[data-alv-arrow]').forEach(function (btn) {
      if (btn.__alv) return; btn.__alv = true;
      btn.addEventListener('click', function () {
        var track = btn.closest('.alv').querySelector('.alv-track');
        var card = track.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 12 : 300;
        track.scrollBy({ left: btn.dataset.alvArrow === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
  }

  function autoslide(root) {
    root.querySelectorAll('[data-alv-autoslide]').forEach(function (track) {
      if (track.__alvSlide) return; track.__alvSlide = true;
      var ms = parseInt(track.dataset.alvAutoslide, 10) * 1000;
      if (!ms || track.children.length < 2) return;
      var paused = false;
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () {
        if (paused || document.hidden) return;
        var w = track.clientWidth;
        var atEnd = track.scrollLeft + w >= track.scrollWidth - 5;
        track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + w, behavior: 'smooth' });
      }, ms);
    });
  }

  function init() { autoslide(document); bind(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); autoslide(e.target); });
})();
